/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Sending_DoneInputs */

const ja_contact_sending_done = /** @type {(inputs: Contact_Sending_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了しました。`)
};

const en_contact_sending_done = /** @type {(inputs: Contact_Sending_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done!`)
};

/**
* | output |
* | --- |
* | "Done!" |
*
* @param {Contact_Sending_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_sending_done = /** @type {((inputs?: Contact_Sending_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Sending_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_sending_done(inputs)
	return en_contact_sending_done(inputs)
});